module.exports = __webpack_public_path__ + "static/media/loader.245073fb.gif";